import React from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  cell: {
    width: "100%",
    height: "initial",
    lineHeight: "normal",
    textAlign: "left",
  },
  employee: {
    padding: "15px",
    paddingLeft: "0px",
  },
}));

const TimeOffRequestEmployeeCell = (props) => {
  const classes = useStyles();

  const renderEmployee = (emp) => {
    return `${emp.employeeLastName}, ${emp.employeeFirstName} (${emp.employeeId})`;
  };

  return (
    <div className={classes.cell} data-testid="tor-employee-cell">
      <div className={classes.employee}>{renderEmployee(props.empData)}</div>
    </div>
  );
};

export default TimeOffRequestEmployeeCell;
